module.exports = __webpack_public_path__ + "img/service3-3.687621e8.webp";